export function Health() {
  return (
    <div className="page-narrow">
      <h1>Application Health</h1>
      <div className="card">
        <p>
          Status: <strong className="success">ok</strong>
        </p>
        <p>
          Application: <strong className="success">running</strong>
        </p>
      </div>
    </div>
  );
}